import React from 'react';
import LoginLink from 'core/modules/LoginLink/LoginLink';

import './LargeNagSignIn.scss';

function LargeNagSignIn() {
  return (
    <div className="mn_largeNagSignIn">
      <div className="mn_signInButtonWrap">
        <LoginLink className="mn_button mn_signInButton" isource="big mobile nag">
          Sign in now
        </LoginLink>
      </div>
    </div>
  );
}

export default LargeNagSignIn;
